module.exports = __webpack_public_path__ + "static/media/logo_fetag.f029ff2a.jpg";